import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import { appWrap } from '../../wrapper';
import './Header.scss';


const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          <div className='badge-docu'>
            <p className="p-text">
              <b>
                Welcome to my portfolio!
              </b>
            </p>
            <br />
            <h1 className="head-name">I'm Christopher Lumen</h1> <br />

            <p className="p-text">

              I am a web developer with a passion for creating intuitive, user-friendly web experiences. <br />
              On this site, you will find a selection of my recent projects, each showcasing my skills in HTML, CSS, and JavaScript, Next JS, React JS as well as my ability to design and develop visually appealing and responsive websites. <br />
              I am always looking for ways to improve my skills and stay up-to-date with the latest technologies, and I am excited about the opportunity to work on new and challenging projects. <br />
              Thank you for visiting my portfolio. I hope you enjoy exploring my work and please don't hesitate to contact me if you have any questions or would like to collaborate on a project.



            </p>

          </div>
        </div>

        {/* <div className="tag-cmp app__flex">
          <p className="p-text"></p>

        </div> */}
      </div>
    </motion.div >

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <img src={images.thops4} alt="profile_bg" className='header-image-blur' />
      {/* <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      /> */}
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[images.react, images.tailwind, images.redux, images.next].map((circle, index) => (
        <div className="circle-cmp app__flex" key={`circle-${index}`}>
          <img src={circle} alt="profile_bg" />
        </div>
      ))}
    </motion.div>
  </div >
);

export default appWrap(Header, 'home');